<p>bulk-search-export works!</p>
